import React, { ReactNode } from 'react'
import { Helmet } from 'react-helmet'

interface ISeoProps {
  children?: ReactNode
  description: string
  keywords?: string
  title: string
  image: string
  url: string
}

export default function Seo({
  keywords = 'Dooer, fakturering, billing, bokföring, redovisning, accounting, tool, finance',
  description,
  children,
  title,
  image,
  url,
}: ISeoProps) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta content={title} name="title" />
      <meta content={description} name="description" />
      <meta content="website" property="og:type" />
      <meta content={url} property="og:url" />
      <meta content={title} property="og:title" />
      <meta content={description} property="og:description" />
      <meta content={image} property="og:image" />
      <meta content="summary_large_image" property="twitter:card" />
      <meta content={url} property="twitter:url" />
      <meta content={title} property="twitter:title" />
      <meta content={description} property="twitter:description" />
      <meta content={image} property="twitter:image" />
      <link href={url} rel="canonical" />

      <meta content={keywords} name="keywords" />

      <meta content="1741032426115146" property="fb:app_id" />
      <meta content="image/png" property="og:image:type" />
      <meta content="1200" property="og:image:width" />
      <meta content="630" property="og:image:height" />
      <meta content="Dooer" property="og:site_name" />
      <meta content="@dooerhq" name="twitter:site" />
      <meta content="Dooer" name="author" />

      {children}
    </Helmet>
  )
}
